<template>
    <div>
        <b-modal v-if="!passwordVisible && userVisible" v-model="userVisible" id="personnalInfo" centered @close="onClose()" @hide="onClose()"><!-- v-if="ToggleForm == true" :visible="Visible" -->
            <template #modal-header="{ close }">
                <h6><b-icon icon="person-fill" class="mr-2" />{{$t('PersonalInfo')}}</h6>
                <b-col cols="3" class=" pr-0 p-1 pl-4 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Close')"  />
                </b-col>
            </template>

            <!-- Formulaire des données personnelles -->
            <b-card no-body class="pl-2 pr-2 pb-0 pt-2">
                <b-form>
                    <b-form-group
                        :label="$t('LastName')"
                        label-cols-sm="4"
                        label-for="LastName"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="LastName">
                            <b-form-input
                                type="text"
                                :state="personnalInfo.LastName ? null : false"
                                v-model="personnalInfo.LastName" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{ $t('PleaseEnterALastName') }} <!--Veuillez entrer un nom-->
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('FirstName')"
                        label-cols-sm="4"
                        label-for="FirstName"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="FirstName">
                            <b-form-input
                                type="text"
                                :state="personnalInfo.FirstName ? null : false"
                                v-model="personnalInfo.FirstName" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{ $t('PleaseEnterAFirstName') }} <!--Veuillez entrer un prénom-->
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Company')"
                        label-cols-sm="4"
                        label-for="company"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="company">
                            <b-form-input
                                type="text"
                                :state="personnalInfo.Company ? null : false"
                                v-model="personnalInfo.Company" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{ $t('PleaseEnterCompanyName') }} <!-- Veuillez entrer le nom de l'entreprise -->
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Function')"
                        label-cols-sm="4"
                        label-for="function"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="function">
                            <b-form-input
                                type="text"
                                v-model="personnalInfo.Function" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Language')"
                        label-cols-sm="4"
                        label-for="langage"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="langage">
                            <b-form-select size="sm"
                                v-model="personnalInfo.Language"
                                :state="personnalInfo.Language ? null : false"
                                :options="languagesOptions" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Login')"
                        label-cols-sm="4"
                        label-for="login"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="login">
                            <b-form-input
                                type="text"
                                v-model="personnalInfo.Login" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Password')"
                        label-cols-sm="4"
                        label-for="login"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-button v-if="!personnalInfo.SsoAuthorityRef" @click="passwordVisible = true" variant="outline-secondary" pill>{{$t('ChangePassword')}}</b-button>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Email')"
                        label-cols-sm="4"
                        label-for="email"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="email">
                        <b-form-input
                                type="email"
                                v-model="personnalInfo.Email" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('RegistrationDate')"
                        label-cols-sm="4"
                        label-for="registrationDate"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="registrationDate">
                            <b-form-input
                                type="text"
                                :value="renderDate(personnalInfo.RegistrationDate)"
                                readonly />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('LastVisit')"
                        label-cols-sm="4"
                        label-for="lastVisit"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="lastVisit">
                            <b-form-input
                                type="text"
                                :value="renderDate(personnalInfo.LastVisit)"
                                readonly />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('Profile')"
                        label-cols-sm="4"
                        label-for="profil"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="profil">
                            <b-form-input
                                type="text"
                                v-model="personnalInfo.Profil" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                        :label="$t('GraphTheme')"
                        label-cols-sm="4"
                        label-for="graphTheme"
                        label-class="pt-0 pb-0 pr-0 pt-2"
                        label-align-sm="left">
                        <b-input-group id="graphTheme">
                            <b-form-select size="sm"
                                v-model="personnalInfo.GraphTheme"
                                :state="personnalInfo.GraphTheme ? null : false"
                                :options="optionsGraph" />
                        </b-input-group>
                    </b-form-group>
                    <b-form-group
                    :label="$t('DCxModeTheme')"
                    label-cols-sm="4"
                    label-for="modeTheme"
                    label-class="pt-0 pb-0 pr-0 pt-2"
                    label-align-sm="left">
                    <b-input-group id="modeTheme">
                        <b-form-select size="sm"
                            v-model="personnalInfo.ModeTheme"
                            :state="personnalInfo.ModeTheme ? null : false"
                            :options="optionsMode" />
                    </b-input-group>
                    </b-form-group>
                </b-form>
            </b-card>
            <template #modal-footer="{ cancel }">
                <b-button @click="savePersonnalData" variant="secondary" pill><font-awesome-icon icon="save"/> {{$t('Save')}}</b-button>
            </template>
        </b-modal>

        <b-modal v-if="passwordVisible" v-model="passwordVisible" id="passwordInfo" centered @close="onClose()" @hide="onClose()">
            <template #modal-header="{ close }">
                <b-col cols="3">
                    <b-icon-arrow-left role="button" font-scale="1" @click="userVisible = true; passwordVisible = false" v-b-tooltip.hover :title="$t('Back')"/> 
                </b-col>
                <h6><b-icon icon="person-fill" class="mr-2" />{{ $t('ChangePassword')}}</h6>
                <b-col cols="3" class=" pr-0 p-1 pl-4 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Close')"  />
                </b-col>
            </template>
            
            <!-- Formulaire de changement de mot de passe -->
            <b-card no-body class="pl-2 pr-2 pb-0 pt-2">
                <PasswordInput 
                    v-model="password" 
                    :OldPassword.sync="oldPassword"
                    :EnableOldPassword="true" 
                    :ShowSplitBar="true"
                    :ShowLabel="true"
                    :HasPasswordPolicy="hasPasswordPolicy" 
                    :MinCharLength="minCharLength" 
                    :MinUpperCase="minUpperCase" 
                    :MinDigit="minDigit" 
                    :MinSpecialChar="minSpecialChar"
                    :ListSpecialChar="listSpecialChar"/>
            </b-card>
            <template #modal-footer="{ cancel }">
                <b-button @click="savePassword" variant="secondary" pill :disabled="oldPassword.length < 1 || password.length < 1"><font-awesome-icon icon="save"  /> {{ $t('Save') }}</b-button>
            </template>
        </b-modal>

        <!-- Toaster d'affichage des erreurs des 2 formulaires -->
        <b-toast id="errorToast" variant="danger" solid auto-hide-delay="5000" toaster="b-toaster-top-center">
                <template #toast-title>
                    <b-icon icon="exclamation-circle" class="h4 mt-2 mr-2" />
                    <b>{{ $t('Errors') }}</b>
                </template>
                <b-list-group>
                    <b-list-group-item v-for="(error, index) in errorList" :key="index" variant="danger" style="cursor: pointer;">
                        {{ error }}
                    </b-list-group-item>
                </b-list-group>
        </b-toast>
    </div>
</template>

<script lang="ts">
	import Component from 'vue-class-component';
    import { Getter } from "vuex-class";
    import { PropSync, Vue } from 'vue-property-decorator';
    import axios from "axios";
    import Dictionary from '@/types/Dictionary';
    import { API_URL } from '@/App.settings';
    import LanguageEnum from '@/enums/LanguageEnum';
    import { ConnectionUtils } from '@/components/commons/Utils';
    import ListItem from "@/types/fields/ListItem";
    import locales from "./locales/PersonalInfo.json";
    import PasswordInput from '@/components/commons/PasswordInput.vue';

    /** Composant d'affichage et de mise à jour des informations personnelles de l'utilisateur connecté */
    @Component({
        components: {
            PasswordInput
        },
        i18n: { messages : locales}
    })
	export default class PersonnalInfo extends ConnectionUtils {
        /** String contenant la valeur de l'input nouveau mot de passe */
        private password: string = ""; 

        /** String contenant la valeur de l'input de l'ancien mot de passe */
        private oldPassword: string = "";

        /** Liste les erreurs lors de la vérification des formulaires (PersonnalInfo, Password) */
        public errorList: string [] = [];

        /** Le mot de passe doit-il respecter une politique de sécurité ? */
        private hasPasswordPolicy: boolean = false;

        /** Nombre de caractères requis */
        private minCharLength: Number = 8;

        /** Nombre de chiffres requis */
        private minDigit: Number = 1;

        /** Nombre de caractères spéciaux requis */
        private minSpecialChar: Number = 1;

        /** Nombre de lettres majuscules requis */
        private minUpperCase: Number = 1;

        /** Liste des caractères spéciaux autorisés */
        private listSpecialChar: string = "@!";

        /** Variable privée : Options du Form-Select */
        private languagesOptions: { value: Number, text: string }[] = [];

        /** Variable privée : Option couleurs pour les graphiques */
        private optionsGraph: {value: number, text:string}[]= [];

        /** Variable privée : Options pour le mode sombre ou non  */
        private optionsMode = [
            { value: 'light', text: this.$t('LightMode').toString() },
            /** @todo Mode sombre désactivé tant que pas implémenté */
            // { value: 'dark', text: "Sombre" },
        ];

        /** Paramétre initiaux des informations utilisateur */
        private personnalInfo: UserInfo = {
            FirstName: "",
            LastName: "",
            Company: "",
            Function: "",
            Language: LanguageEnum.French,
            Login: "",
            Email: "",
            RegistrationDate: null,
            LastVisit: null,
            Profil: "",
            GraphTheme: 1,
            ModeTheme: 'light',
            SsoAuthorityRef: undefined,
        };

        /** Retourne string vide si la date == 01/01/0001 */
        public renderDate(value){
            if(value == '01/01/0001')
                return '';
            else
                return value;
        }

        /** Model pour l'affiche de la modal */
        @PropSync('Visible')
        public userVisible!: boolean;

        /** Bool pour affichage fenêtre mot de passe */
		public passwordVisible: boolean = false;

        /** Variable publique : Informations utilisateur*/
        public PersonnalInfo = this.personnalInfo;

        /** Getter pour obtenir une liste */
        @Getter('GetListItems')
        protected listItems!: (listName: string) => ListItem[];
    
        /** Méthode de validation et enregistrement du nouveau mot de passe */
        private async savePassword(){
            /** Liste les erreurs pour le toaster */
            let errorList: string[] = [];

            if(!this.password)
                errorList.push(this.$t('PleaseEnterYourPassword').toString()); // "Veuillez entrer votre mot de passe"
            
            if(this.password === this.oldPassword)
                errorList.push(this.$t('NewDifferentOldPassword').toString()); //"Votre nouveau mot de passe doit être différent de l'ancien"
            
            /** Si lists erreurs non vide */
            if(errorList.length > 0){
                this.errorList = errorList;
                this.$bvToast.show('errorToast');
                return;
            }

            /** Si aucune erreur lors de la vérification du formulaire */
            this.$store.dispatch("ShowLoadingMask", this.$t('SaveInProgress'));   // "Sauvegarde en cours..."
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["NewPassword"] = this.password;
            args["OldPassword"] = this.oldPassword;

            // Interroge l'API correspondant à la modification du mot de passe
            await axios.post(API_URL + "User/UpdatePassword", args).then((response) => {
                if (response && response.data) {
                    this.$bvToast.toast(this.$t('PasswordChanged').toString(), {
                        title: this.$t('Recording').toString(),
                        autoHideDelay: 3000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                    setTimeout(()=>{
                        this.logOut()
                    },2000);
                }
            })
            .catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('PasswordChangedFailed').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            })
            .finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            })
        }

        /** Sauvegarde des données de l'utilisateur via requete API */
        private async savePersonnalData(){
            /** Liste les erreurs pour le toaster */
            let errorList: string[] = [];

            if(this.personnalInfo.FirstName === "")
                errorList.push(this.$t('PleaseEnterYourFirstName').toString()); // "Veuillez entrer votre prénom"

            if(this.personnalInfo.LastName === "")
                errorList.push(this.$t('PleaseEnterYourLastName').toString()); // "Veuillez entrer votre nom"

            if(this.personnalInfo.Company === "")
                errorList.push(this.$t('PleaseEnterYourCompanyName').toString() ); // "Veuillez entrer le nom de votre entreprise"

            if(errorList.length > 0){
                this.errorList = errorList;
                this.$bvToast.show('errorToast');
            }

            if(errorList.length == 0){
                this.$store.dispatch("ShowLoadingMask", this.$t('SaveInProgress'));   // "Sauvegarde en cours..."

                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                args["Data"] = JSON.stringify(this.personnalInfo);

                // Interroge l'API correspondant au informations utilisateurs
                await axios.post(API_URL + "User/UpdatePersonalData", args).then(async (response) => {
                    if (response && response.data) {
                        /** Mise à jour des données de session pour récupérer la langue à jour dans l'application */
                        await this.$store.dispatch("SessionStore/Load");

                        this.$bvToast.toast(this.$t('DataSaved').toString(), { // "Vos données ont été enregistrées avec succès."
                            title: this.$t('Recording').toString(),
                            autoHideDelay: 3000,
                            variant: "success",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }
                })
                .catch(err => {
                    this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                        title: this.$t('Error').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                })
                .finally(() => {
                    // Masque l'overlay
                    this.$store.dispatch("HideLoadingMask", {});
                });
            }
        }

        /** Chargement des données de l'utilisateur via requete API lors de la création du composant */
        private async loadPersonnalData() {
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            // Interroge l'API correspondant au informations utilisateurs
            await axios.post(API_URL + "User/GetPersonalData", args).then((response) => {
                if (response && response.data) {
                    this.personnalInfo = response.data;
                }
                else {  // Ouvre le formulaire vide
                    this.personnalInfo = {
                        FirstName: "",
                        LastName: "",
                        Company: "",
                        Function: "",
                        Language: null,
                        Login: "",
                        Email: "",
                        RegistrationDate: null,
                        LastVisit: null,
                        Profil : "",
                        GraphTheme: 1,
                        ModeTheme: 'light',
                        SsoAuthorityRef: undefined
                    };
                }
            })
            .catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                // Masque l'overlay
                this.$store.dispatch("HideLoadingMask", {});
            });
        }


        /** Charge la politique de mot de passe du compte client auquel appartient le login demandeur */
        private async loadPasswordPolicy(){
            /** Le token est crypté, il doit être décrypté par le serveur */
            const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

            /** Effectue une vérification du token et une initialisation du formulaire */
            await axios.post(API_URL + "User/GetPasswordParameters", args).then(async (response) => {
                if(response && response.data) {
                    /** Indique si la politique de sécurité doit être appliquée */
                    this.hasPasswordPolicy = response.data.HasPasswordPolicy;
                    this.minCharLength = response.data.CharLength;
                    this.minDigit = response.data.CharDigit;
                    this.minSpecialChar = response.data.CharSpecial;
                    this.minUpperCase = response.data.CharUpperCase;
                    this.listSpecialChar = response.data.CharSpecialList;
                }
            }).catch((err) =>{
                console.error(err);

                // Masque l'overlay
                this.$store.dispatch("HideLoadingMask", {});
            });
        }

        /** Renvoie de la données Visible au composant parent pour la gestion du boolean */
        private onClose(){
            this.userVisible = false;
        }

        async created() {
            this.$store.dispatch("ShowLoadingMask", this.$t('LoadingInProgress'));

            /** Attribution des options de couleur pour les graphiques */
            await this.$store.dispatch("LoadListItems", [{ listName:'GraphThemeName'}, { listName: 'Language'}]);
            let graphColors = this.listItems("GraphThemeName").sort((a,b) => a.Id < b.Id ? -1 : 1);
            this.languagesOptions = this.listItems("Language").map(p => ({
                value: p.Id,
                text: p.Label
            }));
            this.optionsGraph = [];
            for(let i=0; i< graphColors.length; i++) {
                this.optionsGraph.push({value: graphColors[i].Id, text: graphColors[i].Label});
            }

            await this.loadPasswordPolicy();

            await this.loadPersonnalData();

            this.$store.dispatch("HideLoadingMask", {});
        }
    }

    /** Classe UserInfo  */
    type UserInfo = {
        FirstName: string,
        LastName: string,
        Company: string,
        Function: string,
        Language: LanguageEnum,
        Login: string,
        Email: string,
        RegistrationDate: Date,
        LastVisit: Date,
        Profil : string,
        GraphTheme: number,
        ModeTheme: string,
        SsoAuthorityRef: number|null
    }
</script>

<style scoped>
</style>